import React, { useEffect, useState, useLayoutEffect, useRef } from 'react'
import { Box } from '@material-ui/core'

// This variable specifies how far should be component from the bottom to call it visible
const OFFSET = 50

export interface ScrollVisibleWrapper {
  onChange: (isVisible: boolean) => void;
  children: React.ReactNode;
}

export const ScrollVisibleWrapper:React.FC<ScrollVisibleWrapper> = ({ onChange, ...props }) => {
  const prevIsVisible = useRef<null | boolean>(null)
  const alternativesBoxRef: React.MutableRefObject<any> = useRef(null)
  const [isVisible, setVisible] = useState(false);
  const handleScroll = () => {
    if(alternativesBoxRef.current && document.body.clientHeight){
      const {bottom, top} = alternativesBoxRef.current?.getBoundingClientRect()
      const currentIsVisible = (top + window.innerHeight/2) < window.innerHeight && (bottom - window.innerHeight/2) >= 0
      
      if (prevIsVisible.current === false && currentIsVisible && !isVisible) {
        setVisible(true)
        onChange && onChange(true)
      }
      if (prevIsVisible.current === true && !currentIsVisible && isVisible) {
        setVisible(false)
        onChange && onChange(false)
      }
      prevIsVisible.current = currentIsVisible;
    }
  }

  useLayoutEffect(()=>{
    if(alternativesBoxRef.current && document.body.clientHeight){
      const {bottom, top} = alternativesBoxRef.current?.getBoundingClientRect()
      const currentIsVisible = top < window.innerHeight && bottom >= 0
      setVisible(currentIsVisible)
      onChange && onChange(currentIsVisible)
      prevIsVisible.current = currentIsVisible;
    }
  }, [])

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [isVisible])

  return <Box ref={alternativesBoxRef} {...props} />
}

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>{
  onVisible?: () => void;
  onHide?: () => void;
}

export const ScrollPassWrapper:React.FC<Props> = ({ onVisible, onHide, ...props }) => {
  const visibleRef = useRef(false)
  const alternativesBoxRef: React.MutableRefObject<any> = useRef(null)
  const handleScroll = () => {
    if (
      !visibleRef.current &&
      alternativesBoxRef.current &&
      document.body.clientHeight
    ) {
      const {bottom} = alternativesBoxRef.current?.getBoundingClientRect()
      if (bottom && bottom + OFFSET < window.innerHeight) {
        onVisible && onVisible()
        visibleRef.current = true
      }
    }
  }

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return <Box ref={alternativesBoxRef} {...props} />
}
